const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivacypolicy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.667,
    height: 24,
    viewBox: "0 0 22.667 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lsleojg06a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 80",
    style: {
      fill: "#9c9c9c"
    },
    d: "M0 0h22.667v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#lsleojg06a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4270",
    d: "M20.454 3.886 11.777.072a.84.84 0 0 0-.679 0L2.421 3.886a.94.94 0 0 0-.546.866v4.637A15.729 15.729 0 0 0 11.1 23.931a.84.84 0 0 0 .669 0A15.729 15.729 0 0 0 21 9.389V4.752a.94.94 0 0 0-.546-.866zm-1.225 5.5a13.885 13.885 0 0 1-7.792 12.655A13.881 13.881 0 0 1 3.646 9.389V5.378l7.792-3.425 7.792 3.425zm-8.77 3.16 3.806-4.03a.851.851 0 0 1 1.252 0 .977.977 0 0 1 0 1.326l-4.432 4.692a.851.851 0 0 1-1.252 0l-2.474-2.62a.977.977 0 0 1 0-1.326.851.851 0 0 1 1.252 0z",
    transform: "translate(-.104)",
    style: {
      fill: "#9c9c9c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacypolicy);
export default __webpack_public_path__ + "static/media/privacypolicy.8e2d34708b4994d771d71d86ef909f0c.svg";
export { ForwardRef as ReactComponent };